export default "__VITE_ASSET__DX8RdouC__"